import gql from 'graphql-tag';
import { factFragment } from '../../../gql/fragments/Fact';
export const factsQuery = gql `
  query facts($matchId: Float!) {
    facts(matchId: $matchId) {
      ...Fact
    }
  }
  ${factFragment}
`;
//# sourceMappingURL=fact.js.map